// FileMedia.model.ts

export interface IFileMedia {
  // fileId: string;
  urlFile: string;
  path: string;
  service: string;
  fileType: string;
}

export class FileMedia {
  urlFile: string;
  path: string;
  service: string;
  fileType: string;

  constructor(data: IFileMedia) {
    this.urlFile = data.urlFile;
    this.path = data.path;
    this.service = data.service;
    this.fileType = data.fileType;
  }
}
